import React from 'react'
import { TypeAssetLottieAnimation } from '../../../lib/types'
import { ContentProps } from '../../renderer'
import { Image } from '../../ui-lib/image'
import { LottieAnimation } from './animation'
import { getAnimationDataSourceUrl } from './sources'
import { Placeholder } from './placeholder'
import { updateAssetCDNUrl } from '../utils'

export const LottieAnimationAsset: React.FC<ContentProps<TypeAssetLottieAnimation>> = (props) => {
  const { className, structure } = props
  const { placeholderImage, animationKey, altTitle, altAttribute, loopAnimation, dropShadow, internalName } =
    structure.fields || {}

  if (!placeholderImage && !animationKey) {
    return null
  }

  return (
    <div className={className} data-component-id={internalName}>
      <LottieAnimation
        dataSourceUrl={getAnimationDataSourceUrl(animationKey)}
        placeholder={
          placeholderImage?.fields.file?.url ? (
            <Image alt="" src={updateAssetCDNUrl(placeholderImage?.fields.file?.url ?? '')} />
          ) : (
            <Placeholder />
          )
        }
        altTitle={altTitle}
        altDescription={altAttribute}
        loop={loopAnimation}
        dropShadow={dropShadow}
      />
    </div>
  )
}
